import React from 'react';
import { Link } from 'react-router-dom';

export const isInternalRoute = (url = '') => {
  if (!url || url === '#') return false;
  return url.startsWith('/') && !url.startsWith('//');
};

const TemplateRouterLink = ({ to, href, children, download, ...props }) => {
  const target = to || href || '#';

  if (isInternalRoute(target) && !download) {
    return (
      <Link to={target} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <a href={target} download={download} {...props}>
      {children}
    </a>
  );
};

export default TemplateRouterLink;
